import { Fragment, useEffect, useState } from 'react'

import ReactText from '../../../ReactText'
import { ContentFragment, Elements, RevealCardsProps } from '../../types'

const RevealCardsLargeScreen = (props: RevealCardsProps): JSX.Element => {
  const { contentFragments } = props
  const [revealCardStyle, setRevealCardStyle] = useState({})

  useEffect(() => {
    setRevealCardStyle({
      opacity: 1,
      transform: 'translateY(0px)',
      transition: 'opacity 0.5s, transform 0.5s'
    })
  }, [])

  const getColumnClass = () => {
    if (contentFragments?.length % 3 === 0 || contentFragments?.length === 5) {
      return 'col-lg-4'
    }

    return 'col-lg-3'
  }

  const renderCard = (elements: Elements, id: string) => {
    const { icon, iconAtltxt, description, title } = elements

    return (
      <div className={`card-container ${getColumnClass()}`} data-testid={id}>
        <div className='reveal__card' style={revealCardStyle} tabIndex={0}>
          <div className='reveal__card-content'>
            {icon && <img src={icon?.value} alt={iconAtltxt?.value} className='reveal__card-icon' />}
            {title && <ReactText text={title?.value} className='reveal__card-title' />}
          </div>

          <div className='reveal__card-description'>
            {description && <ReactText text={description?.value} className='description' />}
          </div>
        </div>
      </div>
    )
  }

  return (
    <div className='reveal__cards-grid-large row justify-content-center' data-testid='reveal__cards-grid-large'>
      {contentFragments?.map((item: ContentFragment) => {
        const elements = item?.elements || {}
        const id = item?.id

        return <Fragment key={id}>{renderCard(elements, id)}</Fragment>
      })}
    </div>
  )
}

export default RevealCardsLargeScreen
